import { render, staticRenderFns } from "./AthleteDetails.vue?vue&type=template&id=d4ede7a0&scoped=true&"
import script from "./AthleteDetails.vue?vue&type=script&lang=js&"
export * from "./AthleteDetails.vue?vue&type=script&lang=js&"
import style0 from "./AthleteDetails.vue?vue&type=style&index=0&id=d4ede7a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ede7a0",
  null
  
)

export default component.exports